<div class="px-4 sm:px-8 pb-24 lg:pb-8 pt-20 lg:pt-24 overflow-y-auto h-full w-full print:hidden flex justify-center">
  <div class="bg-white rounded-2xl shadow-sm p-6 w-fit h-fit">
    <div class="flex flex-col items-center justify-center min-h-[400px] text-center">
      <div class="bg-amber-50 rounded-full p-6 mb-6">
        <lucide-icon [img]="icons.ClipboardList" class="w-16 h-16 text-amber-500"></lucide-icon>
      </div>
      <h3 class="text-2xl font-bold text-gray-900 mb-3">Assignments Coming Soon</h3>
      <p class="text-gray-600 max-w-md leading-relaxed">
        This feature is currently in development. Soon you'll be able to create, manage, and track student assignments directly from your lesson plan.
      </p>
      <div class="mt-6 flex items-center gap-2 text-sm text-amber-600 bg-amber-50 px-4 py-2 rounded-full">
        <span class="w-2 h-2 bg-amber-500 rounded-full animate-pulse"></span>
        Work in progress
      </div>
      <button
        (click)="openWishlistModal()"
        class="mt-6 inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white font-semibold px-6 py-3 rounded-full transition-colors duration-200 shadow-md hover:shadow-lg cursor-pointer"
      >
        <lucide-icon [img]="icons.Bell" class="w-5 h-5"></lucide-icon>
        Join Wishlist for Priority Access
      </button>
    </div>
  </div>
</div>

<app-wishlist-modal
  [isOpen]="!!(isWishlistModalOpen$ | async)"
  featureName="Assignments"
  feedbackType="presenter_assignments_wishlist"
  (closed)="closeWishlistModal()"
  (submitted)="onWishlistSubmit($event)"
></app-wishlist-modal>

<!-- Toast notification -->
@if (isToastVisible$ | async) {
  <div class="fixed bottom-20 lg:bottom-6 right-4 lg:right-6 z-50 animate-slide-up">
    <div class="bg-green-600 text-white px-4 sm:px-6 py-3 sm:py-4 rounded-xl shadow-lg flex items-center gap-3 max-w-md">
      <div class="bg-white/20 rounded-full w-8 h-8 flex items-center justify-center shrink-0">
        <lucide-icon [img]="icons.CheckCircle" class="w-5 h-5"></lucide-icon>
      </div>
      <div class="flex-1">
        <p class="font-semibold text-sm sm:text-base">Thanks for joining the wishlist!</p>
        <p class="text-xs sm:text-sm text-green-100">We'll notify you when Assignments is ready.</p>
      </div>
      <button (click)="hideToast()" class="text-white/80 hover:text-white cursor-pointer">
        <lucide-icon [img]="icons.X" class="w-5 h-5"></lucide-icon>
      </button>
    </div>
  </div>
}
